import React from "react";

const DEFAULT = [
  { quote: "The photos doubled our online bookings within a month", attr: "Anna · The Pasta Office" },
  { quote: "Finally — menu photography that doesn't look like menu photography", attr: "Marco · Bar Liberty" },
  { quote: "Calm, fast, and the files were ready before the launch", attr: "Eve · Trader House Group" },
  { quote: "Captured the dish exactly how the chef sees it", attr: "Lewis · Cumulus Inc." },
];

export const TestimonialsMarquee = ({ items = DEFAULT }) => {
  const list = [...items, ...items];
  return (
    <div
      data-testid="testimonials-marquee"
      className="relative overflow-hidden bg-ink text-bone py-8 border-y border-bone/10"
    >
      <div className="flex gap-16 animate-marquee whitespace-nowrap">
        {list.map((t, i) => (
          <div key={i} className="flex items-center gap-6 shrink-0">
            <span className="font-display italic text-2xl md:text-3xl tracking-editorial">
              &ldquo;{t.quote}&rdquo;
            </span>
            <span className="font-mono text-[10px] uppercase tracking-wider3 text-ember">
              — {t.attr}
            </span>
            <span className="text-ember text-2xl">·</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialsMarquee;
